export const wholesalerMenus: Array<IMenu> = [
  {
    role: 'home',
    title: 'خانه',
    icon: 'icon-home_deselect',
    route: '/wholesaler/home',
    main: false,
  },
  {
    role: 'buyers',
    title: 'خریداران',
    icon: 'icon-buyer',
    route: '/wholesaler/buyers',
    main: false,
  },
  {
    role: 'add-ad',
    title: 'ثبت آگهی',
    icon: 'icon-ad',
    route: '/wholesaler/add-ad',
    main: true,
  },
  {
    role: 'chats',
    title: 'پیام ها',
    icon: 'icon-chat',
    route: '/wholesaler/chats',
    main: false,
  },
  {
    role: 'account',
    title: 'حساب من',
    icon: 'icon-account',
    route: '/wholesaler/account',
    main: false,
  },
];
